import gql from "graphql-tag";
export const perjawatanList = gql`
  query perjawatanList {
    perjawatanList(where: { status_rekod: "AKTIF" }) {
      id
      kumpulan_perjawatan
      kod_kumpulan_perkhidmatan
      skim_perkhidmatan_id
      kod_skim_perkhidmatan
      gred
      gred_sspa
      gred_level
      jawatan
      kod_bahcaw_janm
      is_gunasama
      kementerian_id
      skim_perkhidmatan {
        kod
        kod2
        nama
        status
        id
      }
      skim_klasifikasi
      agensi_id
      negeri_id
      bil_jawatan
      bil_isi
      status_rekod
      catatan
    }
  }
`;
export const perjawatanCreate = gql`
  mutation perjawatanCreate(
    $jenis_transaksi: String!
    $gred: String
    $kod_skim_perkhidmatan: String
    $skim_perkhidmatan_id: Float
    $skim_klasifikasi: String
    $kumpulan_perjawatan: String
    $bahagian_janm: String
    $cawangan_janm: String
    $agensi_id: Float
    $no_rujukan_surat: String
    $tarikh_kuat_kuasa: String
    $bil_tambahan: Float
    $bilangan: Float
    $catatan_urusetia: String
    $kod_kumpulan_perkhidmatan: String
    $jawatan: String
    $kod_bahcaw_janm: String
    $kementerian_id: Float
    $bil_jawatan: Float
    $bil_isi: Float
    $status_rekod: String
  ) {
    perjawatanCreate(
      input: {
        gred: $gred
        kod_skim_perkhidmatan: $kod_skim_perkhidmatan
        kumpulan_perjawatan: $kumpulan_perjawatan
        kod_kumpulan_perkhidmatan: $kod_kumpulan_perkhidmatan
        skim_perkhidmatan_id: $skim_perkhidmatan_id
        skim_klasifikasi: $skim_klasifikasi
        jawatan: $jawatan
        kod_bahcaw_janm: $kod_bahcaw_janm
        kementerian_id: $kementerian_id
        agensi_id: $agensi_id
        bil_jawatan: $bil_jawatan
        bil_isi: $bil_isi
        catatan: $catatan_urusetia
        status_rekod: $status_rekod
      }
    ) {
      id
    }
    perjawatanTransCreate(
      input: {
        jenis_transaksi: $jenis_transaksi
        gred: $gred
        kumpulan_perjawatan: $kumpulan_perjawatan
        bahagian_janm: $bahagian_janm
        cawangan_janm: $cawangan_janm
        agensi_id: $agensi_id
        no_rujukan_surat: $no_rujukan_surat
        tarikh_kuat_kuasa: $tarikh_kuat_kuasa
        bil_tambahan: $bil_tambahan
        bilangan: $bilangan
        catatan_urusetia: $catatan_urusetia
      }
    ) {
      id
      oid
    }
  }
`;

export const dataBahcaw = gql`
  query bahCawJanmList {
    bahCawJanmList(where: {}) {
      id
      kod
      nama
      jenis
    }
  }
`;
export const dataKementerian = gql`
  query kementerianList {
    kementerianList(where: {}) {
      id
      kod_kementerian
      nama_kementerian
      status
    }
  }
`;
export const dataAgensi = gql`
  query agensiList {
    agensiList(where: {}) {
      id
      kod_agensi
      nama_agensi
      kementerian_id
      status
    }
  }
`;

export const dataKodSkim = gql`
  query dataKodSkim {
    kodPerkhidmatanSkimList(where: {}) {
      id
      kod
      kod2
      nama
      status
    }
  }
`;

export const perjawatanTransCreate = gql`
  mutation perjawatanTransCreate(
    $perjawatan_id: Int!
    $jenis_transaksi: String!
    $gred: String
    $kod_skim_perkhidmatan: String
    $kumpulan_perjawatan: String
    $bahagian_janm: String
    $cawangan_janm: String
    $agensi_id: Float
    $no_rujukan_surat: String
    $tarikh_kuat_kuasa: String
    $bil_tambahan: Float
    $bil_mansuh: Float
    $bil_isi: Float
    $bilangan: Float
    $catatan_urusetia: String
  ) {
    perjawatanTransCreate(
      input: {
        jenis_transaksi: $jenis_transaksi
        gred: $gred
        kod_skim_perkhidmatan: $kod_skim_perkhidmatan
        kumpulan_perjawatan: $kumpulan_perjawatan
        bahagian_janm: $bahagian_janm
        cawangan_janm: $cawangan_janm
        agensi_id: $agensi_id
        no_rujukan_surat: $no_rujukan_surat
        tarikh_kuat_kuasa: $tarikh_kuat_kuasa
        bil_tambahan: $bil_tambahan
        bil_mansuh: $bil_mansuh
        bilangan: $bilangan
        catatan_urusetia: $catatan_urusetia
        perjawatan_id: $perjawatan_id
      }
    ) {
      id
      oid
    }
    perjawatanUpdate(
      input: {
        id: $perjawatan_id
        bil_jawatan: $bilangan
        bil_isi: $bil_isi
        catatan: $catatan_urusetia
      }
    ) {
      id
    }
  }
`;

export const perjawatanTransCreate2 = gql`
  mutation perjawatanTransCreate2(
    $perjawatan_id: Int!
    $jenis_transaksi: String!
    $jenis_transaksi2: String!
    $gred: String
    $kod_skim_perkhidmatan: String
    $kumpulan_perjawatan: String
    $bahagian_janm: String
    $cawangan_janm: String
    $agensi_id: Float
    $no_rujukan_surat: String
    $tarikh_kuat_kuasa: String
    $bil_tambahan: Float
    $bil_mansuh: Float
    $bilangan: Float
    $catatan_urusetia: String
    $bahcaw_id: Int!
    $is_gunasama: String
  ) {
    perjawatanTransCreate2(
      input: {
        jenis_transaksi: $jenis_transaksi
        jenis_transaksi2: $jenis_transaksi2
        gred: $gred
        kod_skim_perkhidmatan: $kod_skim_perkhidmatan
        kumpulan_perjawatan: $kumpulan_perjawatan
        bahagian_janm: $bahagian_janm
        cawangan_janm: $cawangan_janm
        agensi_id: $agensi_id
        no_rujukan_surat: $no_rujukan_surat
        tarikh_kuat_kuasa: $tarikh_kuat_kuasa
        bil_tambahan: $bil_tambahan
        bil_mansuh: $bil_mansuh
        bilangan: $bilangan
        catatan_urusetia: $catatan_urusetia
        perjawatan_id: $perjawatan_id
        bahcaw_id: $bahcaw_id
        is_gunasama: $is_gunasama
      }
    ) {
      id
      oid
    }
  }
`;

export const perjawatanTransList = gql`
  query PerjawatanTransList($where: JSON) {
    perjawatanTransList(where: $where) {
      id
      jenis_transaksi
      jenis_transaksi2
      perjawatan {
        id
        kumpulan_perjawatan
        kod_skim_perkhidmatan
        gred_sspa
        jawatan
        Bahcaw2 {
          nama
        }
      }
      no_rujukan_surat
      tarikh_kuat_kuasa
      is_gunasama
      catatan_urusetia
      lampiran_meta
      created_at
      pengguna {
        nama_penuh
      }
      bil_changes
    }
  }
`;

/** 
 * 
 */

export const perjawatanMansuh = gql`
  mutation perjawatanTransCreate(
    $perjawatan_id: Int!
    $jenis_transaksi: String!
    $gred: String
    $kod_skim_perkhidmatan: String
    $kumpulan_perjawatan: String
    $bahagian_janm: String
    $cawangan_janm: String
    $agensi_id: Float
    $no_rujukan_surat: String
    $tarikh_kuat_kuasa: String
    $status_rekod: String
    $catatan_urusetia: String
  ) {
    perjawatanTransCreate(
      input: {
        jenis_transaksi: $jenis_transaksi
        gred: $gred
        kod_skim_perkhidmatan: $kod_skim_perkhidmatan
        kumpulan_perjawatan: $kumpulan_perjawatan
        bahagian_janm: $bahagian_janm
        cawangan_janm: $cawangan_janm
        agensi_id: $agensi_id
        no_rujukan_surat: $no_rujukan_surat
        tarikh_kuat_kuasa: $tarikh_kuat_kuasa
        catatan_urusetia: $catatan_urusetia
      }
    ) {
      id
      oid
    }
    perjawatanUpdate(
      input: {
        id: $perjawatan_id
        status_rekod: $status_rekod
        catatan: $catatan_urusetia
      }
    ) {
      id
    }
  }
`;

/**
 * 
 */

export const perjawatanCount = gql`
  query perjawatanCount {
    perjawatanKetuaPerkhidmatan: perjawatanCount(skim_perkhidmatan_id: 1)
    perjawatanKetuaJabatan: perjawatanCount(agensi_id: 1)
    gunaSamaJPA: perjawatanCount(agensi_id: 1, is_gunasama: 0)
    bukanGunaSama: perjawatanCount(agensi_id: 1, is_gunasama: 1)
  }
`;
